import { create } from "zustand";

const getTodayUTCString = (): string => {
  return new Date().toISOString();
};

const get30DaysPastUTCString = (): string => {
  const futureDate = new Date();
  futureDate.setDate(futureDate.getDate() - 30);
  return futureDate.toISOString();
};

interface DateFilterState {
  startDate: string;
  endDate: string;
}

interface DateFilterActions {
  setStartDate: (dateString: string) => void;
  setEndDate: (dateString: string) => void;
}

export const useDateFilterStore = create<DateFilterState & DateFilterActions>((set) => ({
  startDate: get30DaysPastUTCString(),
  endDate: getTodayUTCString(),

  setStartDate: (dateString) => set(() => ({
    startDate: dateString
  })),

  setEndDate: (dateString) => set(() => ({
    endDate: dateString
  })),
}));